export function groupInvoiceHistoryByVersions(invoiceHistory) {
  const groupedHistory = invoiceHistory.reduce((acc, history) => {
    const { version } = history;
    if (!acc[version]) {
      acc[version] = [];
    }
    acc[version].push(history);
    return acc;
  }, {});
  return Object.entries(groupedHistory)
    .map(([version, invoices]) => ({
      version,
      invoices: invoices.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      })
    }))
    .sort((a, b) => {
      return b.version.localeCompare(a.version, undefined, { numeric: true });
    });
}
